var requestAsyncLocalStore = null;
var asyncHeadersCache = /* @__PURE__ */ new WeakMap();
async function setResponseHeaders(cb) {
}
function mergeHeaders(onto, from) {
}
function ensureAsyncLocalID() {
}
async function runWithAsyncLocalContext(cb) {
}
function setServerContext() {
}
function setServerData() {
}
function getServerContext() {
}
function useServerContext() {
}
function getServerData() {
}
export {
  asyncHeadersCache,
  ensureAsyncLocalID,
  getServerContext,
  getServerData,
  mergeHeaders,
  requestAsyncLocalStore,
  runWithAsyncLocalContext,
  setResponseHeaders,
  setServerContext,
  setServerData,
  useServerContext
};
//# sourceMappingURL=one-server-only.native.js.map
